import image from './notFoundItem.png';
import styles from './NotFound.module.css';

function NotFound() {
    return <div className={styles.container_not_found}>
        <img className={styles.image_not_found} src={image} alt={'not found'}/>
        <p>موردی یافت نشد</p>
    </div>
}
export default NotFound;